<script>
    import Header from "./components/header.svelte";
</script>

<svelte:head>
    <title>Error | Wavenet Nimbus</title>
</svelte:head>

<Header login={false} accessDenied={true} isRegisterPage={false}></Header>

<div class="d-flex justify-content-center">
    <div class="card col-md-6 col-sm-12" style="margin-top: 60px;">
        <div class="card-body text-center">
            <span class="material-icons" style="font-size: 120px;">report_problem</span>
            <h2 style="/* margin-bottom: 30px; */">Error</h2>
            <p style="margin-bottom: 5px;">There was a problem and we were unable to complete your request.</p>
            <p>Please get in contact with us or head back to home</p> 
            <p style="margin-bottom: 0px;">
                <a href="https://www.wavenet.co.uk/contact-us" target="_blank" class="btn btn-primary">Contact Us</a>
                <a href="/app" class="btn btn-primary">Back to Home</a>
            </p>
        </div>
    </div>
</div>
	  
